import { gql } from "@apollo/client";
import useWrappedMutation from "../../common/data-fetching/useWrappedMutation.js";

const QUERY_SCOPE = "publicGlobal";
const QUERY_NAME = "publicGlobalLog";

export const QUERY = gql`
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
        $payload: JSON!,
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          payload: $payload,
        )
      }
    }
  `;

export default function useMutationPublicGlobalLog() {
  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME);
}
